module.exports = __webpack_public_path__ + "static/media/2r_background.ceeec3d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/2r_background.png
// module id = 2432
// module chunks = 0